<template>
  <ExActionsPopUp
    :value="value"
    :headline="dialogHeadline"
    :htmlInfo="info"
    :actionLabel="actionLabel"
    @input="$emit('input', $event)"
    @onAction="$emit('onAction')"
    data-testid="detach-position-popup"
    icon="org_icon_position"
    :applyBorderClass="true"
    :width="500"
    :centerHeadline="true"
    actionsTopSpacing="32px"
  >
  </ExActionsPopUp>
</template>
<script setup>
import { computed, defineProps } from 'vue';
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";
const props = defineProps({
    value: {
      type: Boolean,
      default: false
    },
    position_name: {
      type: String,
      default: ""
    },
    parent_name: {
      type: String,
      default: ""
    },
    parentKind: {
      type: String,
      default: "default",
      validator: (v) => ["default", "department", "job-family", "job-category"].includes(v),
    },
    headline: {
      type: String,
      default: "",
    },
    actionLabel: {
      type: String,
      default: "Detach",
    },
});

const dialogHeadline = computed(() => {
  if (props.headline) return props.headline;
  if (props.parentKind === "department") return "Remove Position from Department";
  if (props.parentKind === "job-family") return "Remove Position from Job Family";
  if (props.parentKind === "job-category") return "Remove Position from Job Category";
  return "Detach Position";
});

const info = computed(() => {
  const position = props.position_name || "";
  const parent = props.parent_name || "";
  if (props.parentKind === "department") {
    return `<div style="margin-top: 20px;">You are about to remove Position ${position} from Department ${parent}.</div>`;
  }
  if (props.parentKind === "job-family") {
    return `<div style="margin-top: 20px;">You are about to remove Position ${position} from Job Family ${parent}.</div>`;
  }
  if (props.parentKind === "job-category") {
    return `<div style="margin-top: 20px;">You are about to remove Position ${position} from Job Category ${parent}.</div>`;
  }
  return `<div style="margin-top: 20px;">You are about to detach Position ${position} from ${parent}.<br /><br />This action will irreversibly remove this link and related assignments for this position on the parent object.</div>`;
});
</script>
